// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content .el-link {\n  margin: 0 5px;\n}\n.content h4 {\n  padding-top: 10px;\n  border-top: 1px solid #bbbbbb;\n}", ""]);
// Exports
module.exports = exports;
